import { useEffect, useState } from 'react';
import { Button, Header, Message, Modal, Table } from 'react-frontier';
import { useBreadcrumbs } from '../Hooks';
import { SurveyResponseItem, SurveyQuestionType } from '../SiteClasses';
import { bindClick, formatUnix } from '../SiteUtil';
import API from '../API';

var SurveyResponses = ()=>{
	var { setTitle } = useBreadcrumbs();

	var [responses, setResponses] = useState<SurveyResponseItem[]>(null);
	var [loadError, setLoadError] = useState<string>(null);
	var [modalOpen, setModalOpen] = useState<boolean>(false);
	var [response, setResponse] = useState<SurveyResponseItem>(null);
	var [responseError, setResponseError] = useState<string>(null);

	useEffect(()=>{ setTitle('Encuestas'); }, []);
	useEffect(()=>{
		API.getSurveyResponses().then(res=>{
			if(res.error) return setLoadError(res.message);
			setResponses(res.data || []);
		}).catch(()=>{
			setLoadError('Hubo un error cargando las encuestas contestadas. (SVR-1)');
		});
	}, []);

	var openResponse = (r: SurveyResponseItem)=>{
		setResponse(null);
		setResponseError(null);
		setModalOpen(true);
		API.getSurveyResponse(r.response_id).then(res=>{
			if(res.error) return setResponseError(res.message);
			setResponse(res.data);
		}).catch(()=>{
			setResponseError('Hubo un error cargando las respuestas. (SVR-2)');
		});
	};

	if(loadError) return <Header text='Error' subtext={loadError} />;

	return <div>
		<Table striped style={{ maxWidth: 800, margin: 'auto', marginTop: 20 }}>
			<Table.Head title='Encuestas contestadas'>
				<Table.Row>
					<Table.Cell header>ID</Table.Cell>
					<Table.Cell header>Promotor</Table.Cell>
					<Table.Cell header>Usuario asignado</Table.Cell>
					<Table.Cell header centered>Respuestas</Table.Cell>
					<Table.Cell header>Fecha</Table.Cell>
				</Table.Row>
			</Table.Head>
			<Table.Body>
				{!responses ? (
					<Table.Row>
						<Table.Cell colSpan={5}>
							<Header loading text='Cargando encuestas' style={{ paddingTop: 0 }} />
						</Table.Cell>
					</Table.Row>
				) : responses.length === 0 ? (
					<Table.Row>
						<Table.Cell colSpan={5} empty>No hay encuestas contestadas</Table.Cell>
					</Table.Row>
				) : responses.map(r=>(
					<Table.Row key={`SVRSP-${r.response_id}`} selectable onClick={()=>openResponse(r)}>
						<Table.Cell>{r.response_id}</Table.Cell>
						<Table.Cell>{r.promoter_name}</Table.Cell>
						<Table.Cell>{r.user_assigned_name || 'Sin asignar'}</Table.Cell>
						<Table.Cell centered>{r.answer_count}</Table.Cell>
						<Table.Cell collapsing>{formatUnix(r.date_created, 'dd/MM/yyyy')}</Table.Cell>
					</Table.Row>
				))}
			</Table.Body>
		</Table>
		<Modal open={modalOpen} onClose={bindClick(setModalOpen, false)} size='small'>
			<Modal.Header text={response ? `Encuesta #${response.response_id}` : 'Encuesta'} />
			<Modal.Content style={{ padding: 0, maxHeight: 500, overflowY: 'auto' }}>
				{!!responseError && <Message type='error' list={[responseError]} />}
				{!response && !responseError ? (
					<Header loading text='Cargando respuestas' />
				) : !!response && (
					<Table striped fitted details>
						<Table.Head>
							<Table.Row>
								<Table.Cell header>Pregunta</Table.Cell>
								<Table.Cell header>Respuesta</Table.Cell>
							</Table.Row>
						</Table.Head>
						<Table.Body>
							{(!response.answers || response.answers.length === 0) ? (
								<Table.Row>
									<Table.Cell colSpan={2} empty>Sin respuestas</Table.Cell>
								</Table.Row>
							) : response.answers.map(a=>(
								<Table.Row key={`SVANS-${a.answer_id}`}>
									<Table.Cell>{a.question}</Table.Cell>
									<Table.Cell centered>{a.type_id===SurveyQuestionType.YESNO ? (a.answer==='1' ? 'Sí' : 'No') : a.answer}</Table.Cell>
								</Table.Row>
							))}
						</Table.Body>
					</Table>
				)}
			</Modal.Content>
			<Modal.Actions>
				<Button text='Cerrar' basic size='small' onClick={bindClick(setModalOpen, false)} />
			</Modal.Actions>
		</Modal>
	</div>
}

export default SurveyResponses;
